(function () {
  if (window.rpbCartHandlerInitialized) return;
  window.rpbCartHandlerInitialized = true;

  function updateCartBubble(count) {
    document.querySelectorAll(".cart-count-bubble").forEach(function(bubble) {
      const v = bubble.querySelector("span[aria-hidden='true']");
      const h = bubble.querySelector(".visually-hidden");
      if (v) v.textContent = count;
      if (h) h.textContent = count;
      if (count > 0) { bubble.style.display="flex"; bubble.hidden=false; }
    });
  }

  async function getCart() {
    const root = window.Shopify?.routes?.root || "/";
    const res = await fetch(root+"cart.js", { headers: { Accept: "application/json" }});
    if (!res.ok) throw new Error("cart.js error");
    return res.json();
  }

  async function addToCart(variantId) {
    const root = window.Shopify?.routes?.root || "/";
    const fd = new FormData();
    fd.append("id", variantId); fd.append("quantity", "1");
    const res = await fetch(root+"cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" },
      body: fd
    });
    if (!res.ok) throw new Error("add.js error");
    return res.json();
  }

  async function syncCart() {
    const cart = await getCart();
    updateCartBubble(cart.item_count);
    ["cart:refresh","cart:updated"].forEach(ev => {
      document.dispatchEvent(new CustomEvent(ev, { detail: { cart, source: "lf-upsell" } }));
      window.dispatchEvent(new CustomEvent(ev, { detail: { cart, source: "lf-upsell" } }));
    });
    return cart;
  }

  document.addEventListener("click", async function(e) {
    const btn = e.target.closest(".rpb-add-to-cart-btn");
    if (!btn || btn.classList.contains("loading")) return;
    e.preventDefault(); e.stopPropagation();
    const variantId = btn.getAttribute("data-variant-id");
    const textEl = btn.querySelector(".rpb-btn-text");
    const orig = textEl?.textContent || "Añadir a la cesta";
    btn.classList.add("loading");
    if (textEl) textEl.textContent = "Añadiendo...";
    try {
      await addToCart(variantId);
      await syncCart();
      btn.classList.remove("loading"); btn.classList.add("added");
      if (textEl) textEl.textContent = "✓ Añadido";
      setTimeout(() => { btn.classList.remove("added"); if(textEl) textEl.textContent=orig; }, 1600);
    } catch(err) {
      console.error("[LF Upsell]", err);
      btn.classList.remove("loading");
      if (textEl) textEl.textContent = "Error";
      setTimeout(() => { if(textEl) textEl.textContent=orig; }, 1600);
    }
  });
})();